@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-181_490_406)
public val Res.string.skeleton_finish: StringResource by lazy {
      StringResource("string:skeleton_finish", "skeleton_finish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325852, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464896, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298747, 51),
      ))
    }

@delegate:ResourceContentHash(-1_352_143_028)
public val Res.string.skeleton_info_desc: StringResource by lazy {
      StringResource("string:skeleton_info_desc", "skeleton_info_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325912, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464968, 298),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298799, 166),
      ))
    }

@delegate:ResourceContentHash(251_101_306)
public val Res.string.skeleton_manage_templates: StringResource by lazy {
      StringResource("string:skeleton_manage_templates", "skeleton_manage_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326079, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465267, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298966, 65),
      ))
    }

@delegate:ResourceContentHash(-478_393_226)
public val Res.string.skeleton_name_standard_hint: StringResource by lazy {
      StringResource("string:skeleton_name_standard_hint", "skeleton_name_standard_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326149, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465361, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299032, 71),
      ))
    }

@delegate:ResourceContentHash(1_316_888_554)
public val Res.string.skeleton_new: StringResource by lazy {
      StringResource("string:skeleton_new", "skeleton_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326401, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465681, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299252, 24),
      ))
    }

@delegate:ResourceContentHash(278_467_294)
public val Res.string.skeleton_new_day_template: StringResource by lazy {
      StringResource("string:skeleton_new_day_template", "skeleton_new_day_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326241, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465473, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299104, 57),
      ))
    }

@delegate:ResourceContentHash(242_843_874)
public val Res.string.skeleton_new_definition: StringResource by lazy {
      StringResource("string:skeleton_new_definition", "skeleton_new_definition", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326299, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465547, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299162, 51),
      ))
    }

@delegate:ResourceContentHash(-1_994_480_550)
public val Res.string.skeleton_new_name: StringResource by lazy {
      StringResource("string:skeleton_new_name", "skeleton_new_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326359, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465627, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299214, 37),
      ))
    }

@delegate:ResourceContentHash(1_079_679_377)
public val Res.string.skeleton_no_role: StringResource by lazy {
      StringResource("string:skeleton_no_role", "skeleton_no_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326659, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466031, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299450, 36),
      ))
    }

@delegate:ResourceContentHash(-1_425_802_319)
public val Res.string.skeleton_no_role_clear: StringResource by lazy {
      StringResource("string:skeleton_no_role_clear", "skeleton_no_role_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326430, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465718, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299277, 50),
      ))
    }

@delegate:ResourceContentHash(1_646_744_709)
public val Res.string.skeleton_no_roles_defined: StringResource by lazy {
      StringResource("string:skeleton_no_roles_defined", "skeleton_no_roles_defined", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326497, 161),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 465801, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299328, 121),
      ))
    }

@delegate:ResourceContentHash(-107_057_438)
public val Res.string.skeleton_no_shifts_empty: StringResource by lazy {
      StringResource("string:skeleton_no_shifts_empty", "skeleton_no_shifts_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326704, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466084, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299487, 56),
      ))
    }

@delegate:ResourceContentHash(1_453_603_501)
public val Res.string.skeleton_no_shifts_in_template: StringResource by lazy {
      StringResource("string:skeleton_no_shifts_in_template", "skeleton_no_shifts_in_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326761, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466165, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299544, 74),
      ))
    }

@delegate:ResourceContentHash(501_059_259)
public val Res.string.skeleton_off: StringResource by lazy {
      StringResource("string:skeleton_off", "skeleton_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326836, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466272, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299619, 24),
      ))
    }

@delegate:ResourceContentHash(-1_855_257_405)
public val Res.string.skeleton_remove_one_shift: StringResource by lazy {
      StringResource("string:skeleton_remove_one_shift", "skeleton_remove_one_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326865, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466317, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299644, 65),
      ))
    }

@delegate:ResourceContentHash(-753_178_875)
public val Res.string.skeleton_rename_template: StringResource by lazy {
      StringResource("string:skeleton_rename_template", "skeleton_rename_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 326935, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466407, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299710, 52),
      ))
    }

@delegate:ResourceContentHash(-1_476_088_390)
public val Res.string.skeleton_required_skills: StringResource by lazy {
      StringResource("string:skeleton_required_skills", "skeleton_required_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327000, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466492, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299763, 56),
      ))
    }

@delegate:ResourceContentHash(1_710_256_889)
public val Res.string.skeleton_role_optional: StringResource by lazy {
      StringResource("string:skeleton_role_optional", "skeleton_role_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327065, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466569, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299820, 50),
      ))
    }

@delegate:ResourceContentHash(-1_578_396_025)
public val Res.string.skeleton_select_shift: StringResource by lazy {
      StringResource("string:skeleton_select_shift", "skeleton_select_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327136, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466656, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299871, 45),
      ))
    }

@delegate:ResourceContentHash(-320_221_643)
public val Res.string.skeleton_shift_count: StringResource by lazy {
      StringResource("string:skeleton_shift_count", "skeleton_shift_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327186, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466722, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299917, 64),
      ))
    }

@delegate:ResourceContentHash(1_492_572_514)
public val Res.string.skeleton_shift_definitions: StringResource by lazy {
      StringResource("string:skeleton_shift_definitions", "skeleton_shift_definitions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327251, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466811, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299982, 58),
      ))
    }

@delegate:ResourceContentHash(-1_425_013_615)
public val Res.string.skeleton_shift_template_deleted: StringResource by lazy {
      StringResource("string:skeleton_shift_template_deleted", "skeleton_shift_template_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327435, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 467043, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300170, 87),
      ))
    }

@delegate:ResourceContentHash(176_076_636)
public val Res.string.skeleton_shift_template_deleted_from_day: StringResource by lazy {
      StringResource("string:skeleton_shift_template_deleted_from_day", "skeleton_shift_template_deleted_from_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327306, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 466878, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300041, 128),
      ))
    }

@delegate:ResourceContentHash(-1_912_273_405)
public val Res.string.skeleton_shift_template_used_in: StringResource by lazy {
      StringResource("string:skeleton_shift_template_used_in", "skeleton_shift_template_used_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327523, 207),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 467151, 343),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300258, 191),
      ))
    }

@delegate:ResourceContentHash(-1_403_095_394)
public val Res.string.skeleton_shifts_count: StringResource by lazy {
      StringResource("string:skeleton_shifts_count", "skeleton_shifts_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327731, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 467495, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300450, 45),
      ))
    }

@delegate:ResourceContentHash(872_066_797)
public val Res.string.skeleton_skills_count: StringResource by lazy {
      StringResource("string:skeleton_skills_count", "skeleton_skills_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327777, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 467549, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300496, 45),
      ))
    }

@delegate:ResourceContentHash(1_994_552_619)
public val Res.string.skeleton_start_day_template: StringResource by lazy {
      StringResource("string:skeleton_start_day_template", "skeleton_start_day_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328056, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 467932, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300739, 71),
      ))
    }

@delegate:ResourceContentHash(1_580_913_454)
public val Res.string.skeleton_start_day_template_desc: StringResource by lazy {
      StringResource("string:skeleton_start_day_template_desc", "skeleton_start_day_template_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 327835, 220),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 467607, 324),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300542, 196),
      ))
    }

@delegate:ResourceContentHash(1_084_706_215)
public val Res.string.skeleton_tap_to_add_first_shift: StringResource by lazy {
      StringResource("string:skeleton_tap_to_add_first_shift", "skeleton_tap_to_add_first_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328124, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468016, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300811, 71),
      ))
    }

@delegate:ResourceContentHash(-214_015_652)
public val Res.string.skeleton_template_name_required: StringResource by lazy {
      StringResource("string:skeleton_template_name_required", "skeleton_template_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328216, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468136, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300883, 79),
      ))
    }

@delegate:ResourceContentHash(349_286_928)
public val Res.string.skeleton_total_hours: StringResource by lazy {
      StringResource("string:skeleton_total_hours", "skeleton_total_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328300, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468268, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300963, 44),
      ))
    }

@delegate:ResourceContentHash(487_212_403)
public val Res.string.skeleton_working_week: StringResource by lazy {
      StringResource("string:skeleton_working_week", "skeleton_working_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328349, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468321, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301008, 45),
      ))
    }

@delegate:ResourceContentHash(390_495_943)
public val Res.string.special_day_bridge: StringResource by lazy {
      StringResource("string:special_day_bridge", "special_day_bridge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328399, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468391, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301054, 42),
      ))
    }

@delegate:ResourceContentHash(265_920_031)
public val Res.string.special_day_detail_bridge: StringResource by lazy {
      StringResource("string:special_day_detail_bridge", "special_day_detail_bridge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328434, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468434, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301097, 81),
      ))
    }

@delegate:ResourceContentHash(-1_304_211_018)
public val Res.string.special_day_detail_event: StringResource by lazy {
      StringResource("string:special_day_detail_event", "special_day_detail_event", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328508, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468544, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301179, 48),
      ))
    }

@delegate:ResourceContentHash(1_221_240_143)
public val Res.string.special_day_detail_long_weekend: StringResource by lazy {
      StringResource("string:special_day_detail_long_weekend", "special_day_detail_long_weekend", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328641, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468693, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301308, 63),
      ))
    }

@delegate:ResourceContentHash(1_169_833_585)
public val Res.string.special_day_detail_long_weekend_holiday: StringResource by lazy {
      StringResource("string:special_day_detail_long_weekend_holiday", "special_day_detail_long_weekend_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328557, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468593, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301228, 79),
      ))
    }

@delegate:ResourceContentHash(2_126_588_380)
public val Res.string.special_day_detail_summer: StringResource by lazy {
      StringResource("string:special_day_detail_summer", "special_day_detail_summer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328709, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468773, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301372, 73),
      ))
    }

@delegate:ResourceContentHash(826_494_679)
public val Res.string.special_day_detail_winter: StringResource by lazy {
      StringResource("string:special_day_detail_winter", "special_day_detail_winter", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328771, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468871, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301446, 81),
      ))
    }

@delegate:ResourceContentHash(1_827_696_945)
public val Res.string.special_day_long_weekend: StringResource by lazy {
      StringResource("string:special_day_long_weekend", "special_day_long_weekend", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328857, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 468989, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301528, 48),
      ))
    }

@delegate:ResourceContentHash(1_683_696_922)
public val Res.string.special_day_more: StringResource by lazy {
      StringResource("string:special_day_more", "special_day_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328910, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469058, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301577, 32),
      ))
    }

@delegate:ResourceContentHash(-388_316_674)
public val Res.string.special_day_summer: StringResource by lazy {
      StringResource("string:special_day_summer", "special_day_summer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328943, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469091, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301610, 46),
      ))
    }

@delegate:ResourceContentHash(1_897_575_707)
public val Res.string.special_day_winter_break: StringResource by lazy {
      StringResource("string:special_day_winter_break", "special_day_winter_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 328982, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469154, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301657, 48),
      ))
    }

@delegate:ResourceContentHash(-584_887_651)
public val Res.string.split_absence_failed: StringResource by lazy {
      StringResource("string:split_absence_failed", "split_absence_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329023, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469211, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301706, 136),
      ))
    }

@delegate:ResourceContentHash(-1_327_895_660)
public val Res.string.split_action: StringResource by lazy {
      StringResource("string:split_action", "split_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329245, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469501, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301904, 40),
      ))
    }

@delegate:ResourceContentHash(-1_619_174_541)
public val Res.string.split_action_description: StringResource by lazy {
      StringResource("string:split_action_description", "split_action_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329184, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469420, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301843, 60),
      ))
    }

@delegate:ResourceContentHash(-1_220_100_051)
public val Res.string.split_done: StringResource by lazy {
      StringResource("string:split_done", "split_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329290, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469566, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301945, 70),
      ))
    }

@delegate:ResourceContentHash(324_316_535)
public val Res.string.split_handover: StringResource by lazy {
      StringResource("string:split_handover", "split_handover", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329468, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469772, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302107, 42),
      ))
    }

@delegate:ResourceContentHash(-1_303_362_084)
public val Res.string.split_handover_outside: StringResource by lazy {
      StringResource("string:split_handover_outside", "split_handover_outside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329365, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469661, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302016, 90),
      ))
    }

@delegate:ResourceContentHash(-819_838_731)
public val Res.string.split_intro: StringResource by lazy {
      StringResource("string:split_intro", "split_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329519, 211),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 469827, 327),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302150, 203),
      ))
    }

@delegate:ResourceContentHash(637_589_033)
public val Res.string.split_part_first: StringResource by lazy {
      StringResource("string:split_part_first", "split_part_first", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329731, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470155, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302354, 56),
      ))
    }

@delegate:ResourceContentHash(1_637_739_466)
public val Res.string.split_part_second: StringResource by lazy {
      StringResource("string:split_part_second", "split_part_second", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329808, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470252, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302411, 69),
      ))
    }

@delegate:ResourceContentHash(-1_883_714_551)
public val Res.string.split_planned_note: StringResource by lazy {
      StringResource("string:split_planned_note", "split_planned_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 329882, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470342, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302481, 142),
      ))
    }

@delegate:ResourceContentHash(1_647_971_647)
public val Res.string.split_preview: StringResource by lazy {
      StringResource("string:split_preview", "split_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330045, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470581, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302624, 57),
      ))
    }

@delegate:ResourceContentHash(-1_880_539_766)
public val Res.string.split_problem_already: StringResource by lazy {
      StringResource("string:split_problem_already", "split_problem_already", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330107, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470647, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302682, 97),
      ))
    }

@delegate:ResourceContentHash(-1_900_796_947)
public val Res.string.split_problem_closed: StringResource by lazy {
      StringResource("string:split_problem_closed", "split_problem_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330213, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470785, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302780, 100),
      ))
    }

@delegate:ResourceContentHash(974_799_634)
public val Res.string.split_problem_missing: StringResource by lazy {
      StringResource("string:split_problem_missing", "split_problem_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330330, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 470954, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302881, 121),
      ))
    }

@delegate:ResourceContentHash(471_075_988)
public val Res.string.split_problem_nobody: StringResource by lazy {
      StringResource("string:split_problem_nobody", "split_problem_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330468, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471144, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303003, 108),
      ))
    }

@delegate:ResourceContentHash(-1_038_459_896)
public val Res.string.split_problem_outside: StringResource by lazy {
      StringResource("string:split_problem_outside", "split_problem_outside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330581, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471301, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303112, 81),
      ))
    }

@delegate:ResourceContentHash(-1_654_393_467)
public val Res.string.split_problem_same_person: StringResource by lazy {
      StringResource("string:split_problem_same_person", "split_problem_same_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330679, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471431, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303194, 105),
      ))
    }

@delegate:ResourceContentHash(-1_735_180_122)
public val Res.string.split_reason_hint: StringResource by lazy {
      StringResource("string:split_reason_hint", "split_reason_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330785, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471569, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303300, 53),
      ))
    }

@delegate:ResourceContentHash(872_128_191)
public val Res.string.split_record_sick_leave: StringResource by lazy {
      StringResource("string:split_record_sick_leave", "split_record_sick_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330847, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471643, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303354, 115),
      ))
    }

@delegate:ResourceContentHash(1_503_965_874)
public val Res.string.split_replacement: StringResource by lazy {
      StringResource("string:split_replacement", "split_replacement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 330959, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471775, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303470, 45),
      ))
    }

@delegate:ResourceContentHash(586_356_399)
public val Res.string.split_save: StringResource by lazy {
      StringResource("string:split_save", "split_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331013, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471849, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303516, 26),
      ))
    }

@delegate:ResourceContentHash(1_729_087_802)
public val Res.string.split_sickness: StringResource by lazy {
      StringResource("string:split_sickness", "split_sickness", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331044, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471892, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303543, 46),
      ))
    }

@delegate:ResourceContentHash(-1_137_262_161)
public val Res.string.split_title: StringResource by lazy {
      StringResource("string:split_title", "split_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331091, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 471951, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303590, 35),
      ))
    }

@delegate:ResourceContentHash(-2_112_240_502)
public val Res.string.split_undo: StringResource by lazy {
      StringResource("string:split_undo", "split_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331220, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472116, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303699, 34),
      ))
    }

@delegate:ResourceContentHash(1_899_860_485)
public val Res.string.split_undone: StringResource by lazy {
      StringResource("string:split_undone", "split_undone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331131, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472011, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303626, 72),
      ))
    }

@delegate:ResourceContentHash(1_373_702_006)
public val Res.string.spmh: StringResource by lazy {
      StringResource("string:spmh", "spmh", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331335, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472251, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303798, 20),
      ))
    }

@delegate:ResourceContentHash(-1_694_258_532)
public val Res.string.spmh_plan: StringResource by lazy {
      StringResource("string:spmh_plan", "spmh_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331259, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472175, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303734, 29),
      ))
    }

@delegate:ResourceContentHash(562_752_640)
public val Res.string.spmh_real: StringResource by lazy {
      StringResource("string:spmh_real", "spmh_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331293, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472213, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303764, 33),
      ))
    }

@delegate:ResourceContentHash(1_625_124_460)
public val Res.string.spreadsheet_problem_corrupt: StringResource by lazy {
      StringResource("string:spreadsheet_problem_corrupt", "spreadsheet_problem_corrupt", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331356, 195),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472272, 287),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303819, 167),
      ))
    }

@delegate:ResourceContentHash(544_174_422)
public val Res.string.spreadsheet_problem_empty: StringResource by lazy {
      StringResource("string:spreadsheet_problem_empty", "spreadsheet_problem_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331552, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472560, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303987, 61),
      ))
    }

@delegate:ResourceContentHash(1_467_116_610)
public val Res.string.spreadsheet_problem_legacy_xls: StringResource by lazy {
      StringResource("string:spreadsheet_problem_legacy_xls", "spreadsheet_problem_legacy_xls", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331610, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472630, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304049, 150),
      ))
    }

@delegate:ResourceContentHash(-1_977_899_360)
public val Res.string.spreadsheet_problem_not_spreadsheet: StringResource by lazy {
      StringResource("string:spreadsheet_problem_not_spreadsheet", "spreadsheet_problem_not_spreadsheet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331765, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472841, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304200, 135),
      ))
    }

@delegate:ResourceContentHash(-1_193_950_243)
public val Res.string.spreadsheet_problem_password: StringResource by lazy {
      StringResource("string:spreadsheet_problem_password", "spreadsheet_problem_password", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 331897, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 472993, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304336, 152),
      ))
    }

@delegate:ResourceContentHash(-1_795_239_514)
public val Res.string.spreadsheet_problem_too_large: StringResource by lazy {
      StringResource("string:spreadsheet_problem_too_large", "spreadsheet_problem_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332265, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 473521, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304692, 109),
      ))
    }

@delegate:ResourceContentHash(-1_768_518_658)
public val Res.string.spreadsheet_problem_too_large_unpacked: StringResource by lazy {
      StringResource("string:spreadsheet_problem_too_large_unpacked", "spreadsheet_problem_too_large_unpacked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332034, 230),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 473190, 330),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304489, 202),
      ))
    }

@delegate:ResourceContentHash(1_607_634_974)
public val Res.string.staff_check_medical_lower: StringResource by lazy {
      StringResource("string:staff_check_medical_lower", "staff_check_medical_lower", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332375, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 473671, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304802, 49),
      ))
    }

@delegate:ResourceContentHash(1_570_467_757)
public val Res.string.staff_check_ohs_lower: StringResource by lazy {
      StringResource("string:staff_check_ohs_lower", "staff_check_ohs_lower", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332433, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 473741, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304852, 45),
      ))
    }

@delegate:ResourceContentHash(1_376_026_828)
public val Res.string.staff_checks_dates_only: StringResource by lazy {
      StringResource("string:staff_checks_dates_only", "staff_checks_dates_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332483, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 473803, 279),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304898, 171),
      ))
    }

@delegate:ResourceContentHash(-739_144_760)
public val Res.string.staff_checks_edit: StringResource by lazy {
      StringResource("string:staff_checks_edit", "staff_checks_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332655, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474083, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305070, 61),
      ))
    }

@delegate:ResourceContentHash(-176_373_178)
public val Res.string.staff_checks_saved: StringResource by lazy {
      StringResource("string:staff_checks_saved", "staff_checks_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332725, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474229, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305132, 70),
      ))
    }

@delegate:ResourceContentHash(-611_834_002)
public val Res.string.staff_checks_status_only: StringResource by lazy {
      StringResource("string:staff_checks_status_only", "staff_checks_status_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332788, 124),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474348, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305203, 108),
      ))
    }

@delegate:ResourceContentHash(1_856_531_536)
public val Res.string.staff_checks_title: StringResource by lazy {
      StringResource("string:staff_checks_title", "staff_checks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332913, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474529, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305312, 50),
      ))
    }

@delegate:ResourceContentHash(-1_208_090_668)
public val Res.string.staff_chip_medical_expired: StringResource by lazy {
      StringResource("string:staff_chip_medical_expired", "staff_chip_medical_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 332960, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474604, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305363, 62),
      ))
    }

@delegate:ResourceContentHash(90_705_962)
public val Res.string.staff_chip_medical_expiring: StringResource by lazy {
      StringResource("string:staff_chip_medical_expiring", "staff_chip_medical_expiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333019, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474707, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305426, 71),
      ))
    }

@delegate:ResourceContentHash(-737_082_428)
public val Res.string.staff_chip_ohs_expired: StringResource by lazy {
      StringResource("string:staff_chip_ohs_expired", "staff_chip_ohs_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333091, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474815, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305498, 58),
      ))
    }

@delegate:ResourceContentHash(11_130_085)
public val Res.string.staff_chip_ohs_expiring: StringResource by lazy {
      StringResource("string:staff_chip_ohs_expiring", "staff_chip_ohs_expiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333154, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 474910, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305557, 67),
      ))
    }

@delegate:ResourceContentHash(-1_111_034_041)
public val Res.string.staff_competence: StringResource by lazy {
      StringResource("string:staff_competence", "staff_competence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333633, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475661, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306032, 40),
      ))
    }

@delegate:ResourceContentHash(-409_905_646)
public val Res.string.staff_competence_hint: StringResource by lazy {
      StringResource("string:staff_competence_hint", "staff_competence_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333226, 297),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475010, 489),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305625, 281),
      ))
    }

@delegate:ResourceContentHash(-524_119_021)
public val Res.string.staff_competence_independent: StringResource by lazy {
      StringResource("string:staff_competence_independent", "staff_competence_independent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333524, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475500, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305907, 64),
      ))
    }

@delegate:ResourceContentHash(-656_608_599)
public val Res.string.staff_competence_supervised: StringResource by lazy {
      StringResource("string:staff_competence_supervised", "staff_competence_supervised", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333577, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475581, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 305972, 59),
      ))
    }

@delegate:ResourceContentHash(1_438_334_361)
public val Res.string.staff_date_and_status: StringResource by lazy {
      StringResource("string:staff_date_and_status", "staff_date_and_status", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333678, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475722, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306073, 45),
      ))
    }

@delegate:ResourceContentHash(-753_442_036)
public val Res.string.staff_import_back_to_mapping: StringResource by lazy {
      StringResource("string:staff_import_back_to_mapping", "staff_import_back_to_mapping", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333724, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475768, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306119, 64),
      ))
    }

@delegate:ResourceContentHash(-250_072_873)
public val Res.string.staff_import_choose_file: StringResource by lazy {
      StringResource("string:staff_import_choose_file", "staff_import_choose_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333785, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475845, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306184, 52),
      ))
    }

@delegate:ResourceContentHash(-470_266_540)
public val Res.string.staff_import_choose_title: StringResource by lazy {
      StringResource("string:staff_import_choose_title", "staff_import_choose_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333834, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475910, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306237, 73),
      ))
    }

@delegate:ResourceContentHash(-1_910_668_008)
public val Res.string.staff_import_column: StringResource by lazy {
      StringResource("string:staff_import_column", "staff_import_column", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334088, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476208, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306487, 43),
      ))
    }

@delegate:ResourceContentHash(-789_882_727)
public val Res.string.staff_import_column_field: StringResource by lazy {
      StringResource("string:staff_import_column_field", "staff_import_column_field", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333908, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 475996, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306311, 49),
      ))
    }

@delegate:ResourceContentHash(867_233_232)
public val Res.string.staff_import_column_named: StringResource by lazy {
      StringResource("string:staff_import_column_named", "staff_import_column_named", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 333962, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476066, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306361, 65),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString39Resources(map: MutableMap<String, StringResource>) {
  map.put("skeleton_finish", Res.string.skeleton_finish)
  map.put("skeleton_info_desc", Res.string.skeleton_info_desc)
  map.put("skeleton_manage_templates", Res.string.skeleton_manage_templates)
  map.put("skeleton_name_standard_hint", Res.string.skeleton_name_standard_hint)
  map.put("skeleton_new", Res.string.skeleton_new)
  map.put("skeleton_new_day_template", Res.string.skeleton_new_day_template)
  map.put("skeleton_new_definition", Res.string.skeleton_new_definition)
  map.put("skeleton_new_name", Res.string.skeleton_new_name)
  map.put("skeleton_no_role", Res.string.skeleton_no_role)
  map.put("skeleton_no_role_clear", Res.string.skeleton_no_role_clear)
  map.put("skeleton_no_roles_defined", Res.string.skeleton_no_roles_defined)
  map.put("skeleton_no_shifts_empty", Res.string.skeleton_no_shifts_empty)
  map.put("skeleton_no_shifts_in_template", Res.string.skeleton_no_shifts_in_template)
  map.put("skeleton_off", Res.string.skeleton_off)
  map.put("skeleton_remove_one_shift", Res.string.skeleton_remove_one_shift)
  map.put("skeleton_rename_template", Res.string.skeleton_rename_template)
  map.put("skeleton_required_skills", Res.string.skeleton_required_skills)
  map.put("skeleton_role_optional", Res.string.skeleton_role_optional)
  map.put("skeleton_select_shift", Res.string.skeleton_select_shift)
  map.put("skeleton_shift_count", Res.string.skeleton_shift_count)
  map.put("skeleton_shift_definitions", Res.string.skeleton_shift_definitions)
  map.put("skeleton_shift_template_deleted", Res.string.skeleton_shift_template_deleted)
  map.put("skeleton_shift_template_deleted_from_day", Res.string.skeleton_shift_template_deleted_from_day)
  map.put("skeleton_shift_template_used_in", Res.string.skeleton_shift_template_used_in)
  map.put("skeleton_shifts_count", Res.string.skeleton_shifts_count)
  map.put("skeleton_skills_count", Res.string.skeleton_skills_count)
  map.put("skeleton_start_day_template", Res.string.skeleton_start_day_template)
  map.put("skeleton_start_day_template_desc", Res.string.skeleton_start_day_template_desc)
  map.put("skeleton_tap_to_add_first_shift", Res.string.skeleton_tap_to_add_first_shift)
  map.put("skeleton_template_name_required", Res.string.skeleton_template_name_required)
  map.put("skeleton_total_hours", Res.string.skeleton_total_hours)
  map.put("skeleton_working_week", Res.string.skeleton_working_week)
  map.put("special_day_bridge", Res.string.special_day_bridge)
  map.put("special_day_detail_bridge", Res.string.special_day_detail_bridge)
  map.put("special_day_detail_event", Res.string.special_day_detail_event)
  map.put("special_day_detail_long_weekend", Res.string.special_day_detail_long_weekend)
  map.put("special_day_detail_long_weekend_holiday", Res.string.special_day_detail_long_weekend_holiday)
  map.put("special_day_detail_summer", Res.string.special_day_detail_summer)
  map.put("special_day_detail_winter", Res.string.special_day_detail_winter)
  map.put("special_day_long_weekend", Res.string.special_day_long_weekend)
  map.put("special_day_more", Res.string.special_day_more)
  map.put("special_day_summer", Res.string.special_day_summer)
  map.put("special_day_winter_break", Res.string.special_day_winter_break)
  map.put("split_absence_failed", Res.string.split_absence_failed)
  map.put("split_action", Res.string.split_action)
  map.put("split_action_description", Res.string.split_action_description)
  map.put("split_done", Res.string.split_done)
  map.put("split_handover", Res.string.split_handover)
  map.put("split_handover_outside", Res.string.split_handover_outside)
  map.put("split_intro", Res.string.split_intro)
  map.put("split_part_first", Res.string.split_part_first)
  map.put("split_part_second", Res.string.split_part_second)
  map.put("split_planned_note", Res.string.split_planned_note)
  map.put("split_preview", Res.string.split_preview)
  map.put("split_problem_already", Res.string.split_problem_already)
  map.put("split_problem_closed", Res.string.split_problem_closed)
  map.put("split_problem_missing", Res.string.split_problem_missing)
  map.put("split_problem_nobody", Res.string.split_problem_nobody)
  map.put("split_problem_outside", Res.string.split_problem_outside)
  map.put("split_problem_same_person", Res.string.split_problem_same_person)
  map.put("split_reason_hint", Res.string.split_reason_hint)
  map.put("split_record_sick_leave", Res.string.split_record_sick_leave)
  map.put("split_replacement", Res.string.split_replacement)
  map.put("split_save", Res.string.split_save)
  map.put("split_sickness", Res.string.split_sickness)
  map.put("split_title", Res.string.split_title)
  map.put("split_undo", Res.string.split_undo)
  map.put("split_undone", Res.string.split_undone)
  map.put("spmh", Res.string.spmh)
  map.put("spmh_plan", Res.string.spmh_plan)
  map.put("spmh_real", Res.string.spmh_real)
  map.put("spreadsheet_problem_corrupt", Res.string.spreadsheet_problem_corrupt)
  map.put("spreadsheet_problem_empty", Res.string.spreadsheet_problem_empty)
  map.put("spreadsheet_problem_legacy_xls", Res.string.spreadsheet_problem_legacy_xls)
  map.put("spreadsheet_problem_not_spreadsheet", Res.string.spreadsheet_problem_not_spreadsheet)
  map.put("spreadsheet_problem_password", Res.string.spreadsheet_problem_password)
  map.put("spreadsheet_problem_too_large", Res.string.spreadsheet_problem_too_large)
  map.put("spreadsheet_problem_too_large_unpacked", Res.string.spreadsheet_problem_too_large_unpacked)
  map.put("staff_check_medical_lower", Res.string.staff_check_medical_lower)
  map.put("staff_check_ohs_lower", Res.string.staff_check_ohs_lower)
  map.put("staff_checks_dates_only", Res.string.staff_checks_dates_only)
  map.put("staff_checks_edit", Res.string.staff_checks_edit)
  map.put("staff_checks_saved", Res.string.staff_checks_saved)
  map.put("staff_checks_status_only", Res.string.staff_checks_status_only)
  map.put("staff_checks_title", Res.string.staff_checks_title)
  map.put("staff_chip_medical_expired", Res.string.staff_chip_medical_expired)
  map.put("staff_chip_medical_expiring", Res.string.staff_chip_medical_expiring)
  map.put("staff_chip_ohs_expired", Res.string.staff_chip_ohs_expired)
  map.put("staff_chip_ohs_expiring", Res.string.staff_chip_ohs_expiring)
  map.put("staff_competence", Res.string.staff_competence)
  map.put("staff_competence_hint", Res.string.staff_competence_hint)
  map.put("staff_competence_independent", Res.string.staff_competence_independent)
  map.put("staff_competence_supervised", Res.string.staff_competence_supervised)
  map.put("staff_date_and_status", Res.string.staff_date_and_status)
  map.put("staff_import_back_to_mapping", Res.string.staff_import_back_to_mapping)
  map.put("staff_import_choose_file", Res.string.staff_import_choose_file)
  map.put("staff_import_choose_title", Res.string.staff_import_choose_title)
  map.put("staff_import_column", Res.string.staff_import_column)
  map.put("staff_import_column_field", Res.string.staff_import_column_field)
  map.put("staff_import_column_named", Res.string.staff_import_column_named)
}
